import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalSetFeatureDiscovered: ExperimentalMutations['experimentalSetFeatureDiscovered'] =
	(_, { featureKey, pluginKey }, { network: { cfetch } }) => {
		if (!featureKey || !pluginKey) {
			throw new Error('featureKey or pluginKey is missing.');
		}

		return cfetch(`/wiki/rest/feature-discovery/1.0/discovered/${pluginKey}/${featureKey}`, {
			method: 'POST',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(() => ({
			pluginKey,
			featureKey,
		}));
	};
